import {Equality} from "../../../types/GenericTypes";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";
import {AccountId} from "../../types/AccountRecord";

export type EquityPositionRecords = ReadonlyArray<EquityPositionRecord>;

export interface EquityPositionRecord extends CodeAndExchange {
    readonly accountId: AccountId;
    readonly quantity: number;
    readonly averagePrice: number;
}

export function equityPositionMatcher(): Equality<EquityPositionRecord> {
    return (a, b) => {
        return (a.code === b.code) &&
            (a.exchange === b.exchange) &&
            (a.quantity === b.quantity) &&
            (a.averagePrice === b.averagePrice);
    };
}
